export default __webpack_public_path__ + "static/slide-1-41c5b98688d284cc006304f41af4ad27.png";